import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Wind, ChevronLeft, Mail, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import { API } from '@/utils/constants';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
      toast.success("Email envoyé !");
    } catch (error) {
      // Always show success to prevent email enumeration
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-slate-50 to-teal-50 flex items-center justify-center px-6">
        <Card className="w-full max-w-sm bg-white/80 backdrop-blur border-teal-100">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-teal-100 flex items-center justify-center">
              <CheckCircle className="w-8 h-8 text-teal-600" />
            </div>
            <CardTitle className="text-xl font-bold text-stone-800">
              Email envoyé !
            </CardTitle>
            <CardDescription className="text-stone-500">
              Si un compte existe avec l&apos;adresse <strong>{email}</strong>, vous recevrez un email avec les instructions de réinitialisation.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <p className="text-sm text-stone-500 text-center">
                Vérifiez également votre dossier spam.
              </p>
              <Button
                onClick={() => navigate('/login')}
                className="w-full bg-cyan-500 hover:bg-cyan-600"
              >
                Retour à la connexion
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-teal-50 flex items-center justify-center px-6">
      <Card className="w-full max-w-sm bg-white/80 backdrop-blur border-teal-100">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-teal-100 flex items-center justify-center">
            <Mail className="w-8 h-8 text-teal-600" />
          </div>
          <CardTitle className="text-xl font-bold text-stone-800" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Mot de passe oublié
          </CardTitle>
          <CardDescription className="text-stone-500">
            Entrez votre email pour recevoir un lien de réinitialisation
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.com"
                required
                className="mt-1"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-cyan-500 hover:bg-cyan-600"
            >
              {loading ? "Envoi en cours..." : "Envoyer le lien"}
            </Button>
          </form>
          
          <div className="mt-4 text-center">
            <button
              onClick={() => navigate('/login')}
              className="inline-flex items-center gap-1 text-sm text-stone-500 hover:text-teal-600 transition-colors"
            >
              <ChevronLeft size={16} />
              Retour à la connexion
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ForgotPasswordPage;
